import styled from 'styled-components'

export const Container = styled.div`
  min-height: 100vh;
  padding-bottom: 3rem;
`

export const Content = styled.div`
  padding: 1.5rem;
  margin-top: -6rem;
  width: 100%;

  @media (${(props) => props.theme.screens.lg}) {
    padding: 2rem 3rem;
  }

  .sign-up-form {
    max-width: 22rem;

    &__title {
      font-size: 1.25rem;
      text-align: left;
      margin-bottom: 1.5rem;
    }
  }
`

export const AvatarInput = styled.div`
  margin: auto;
  position: relative;
  margin-bottom: 2rem;
  width: fit-content;

  .avatar-input {
    &__image {
      width: 12rem;
      height: 12rem;
      border-radius: 50%;
    }

    &__upload {
      cursor: pointer;
      position: absolute;
      height: 3rem;
      width: 3rem;
      border-radius: 50%;
      background: ${props => props.theme.gradient};
      right: .5rem;
      bottom: .5rem;
      border: 0;
      transition: background 0.2s;

      display: flex;
      align-items: center;
      justify-content: center;

      &:hover {
        background: ${props => props.theme.gradientDarken};
      }

      input {
        display: none;
      }

      svg {
        color: ${props => props.theme.white};
        width: 1.25rem;
        height: 1.25rem;
      }
    }
  }
`
